import React from 'react';
import { Mail, Globe, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and description */}
          <div>
            <img 
              src="/elit-logo.png" 
              alt="Elit Brand Tour" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-slate-400 leading-relaxed">
              El encuentro más importante del canal de tecnología en Argentina.
            </p>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">
              Contacto
            </h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-orange-500 flex-shrink-0" />
                <a href="mailto:marketing@elit.com.ar" className="text-slate-400 hover:text-white transition-colors">
                  marketing@elit.com.ar
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Globe className="w-5 h-5 text-pink-500 flex-shrink-0" />
                <a href="https://www.elit.com.ar" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
                  www.elit.com.ar
                </a>
              </div>
            </div>
          </div>

          {/* Social media */}
          <div>
            <h4 className="text-lg font-semibold mb-4">
              Síguenos
            </h4>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/elitlatam/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/elit.arg/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-400">
            &copy; {new Date().getFullYear()} Elit Brand Tour. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
